import GlobalDispatcher from "./events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default new class ScaleManager {
    constructor() {
        EntryPoint.ScaleManager = this;

        this.data = null;
        this.currentSizes = null;
        this._gameScale = 1;
        this._currentData = null;
    }

    init(data) {
        this.data = data;
        this.calculateCurrentSize();
        this.addListeners();
        this.onResize()
    }

    addListeners() {
        window.addEventListener('resize', this.onResize.bind(this));
        window.addEventListener('fullscreenchange', this.onResize.bind(this));
    }

    calculateCurrentSize() {
        let parent = document.getElementById('container');
        let windowRatio = parent.offsetWidth / parent.offsetHeight;
        this.currentSizes = EntryPoint.mobile
            ? (windowRatio >= 1 ? this.data.gameSize.mobileLandscape : this.data.gameSize.mobilePortrait)
            : this.data.gameSize.desktop;
        if (!this.currentSizes) {
            this.currentSizes = this.data.gameSize;
        }
    }

    onResize() {
        setTimeout(()=>{
            this.calculateCurrentSize();

            if (!this.data.app) {
                return;
            }

            let callback = this.data.type === 'canvas' ? this.correctSizeCanvas : this.correctSizeCSS;
            callback.call(this);

            this._currentData = {
                canvasWidth: this.data.app.view.width,
                canvasHeight: this.data.app.view.height,
                stageX: this.data.app.stage.x,
                stageY: this.data.app.stage.y
            };
            GlobalDispatcher.dispatch('scaleManager:resize', this.currentData);
        }, 0);

    }

    correctSizeCSS(checkSafeZone = true) {
        let parent = this.data.app.view.parentElement;
        let view = this.data.app.view;

        if (this.data.fullSize) {
            view.style.width = '100%';
            view.style.height = '100%';

            let windowRatio = parent.offsetWidth / parent.offsetHeight;
            let gameRatio = this.currentSizes.width / this.currentSizes.height;

            if (windowRatio >= gameRatio) {
                view.width = this.currentSizes.height * windowRatio;
                view.height = this.currentSizes.height;
                this.data.app.stage.x = (view.width - this.currentSizes.width) / 2 ;
                this.data.app.stage.y = 0;
            } else {
                view.height = this.currentSizes.width / windowRatio;
                view.width = this.currentSizes.width;
                this.data.app.stage.x = 0;
                this.data.app.stage.y = (view.height - this.currentSizes.height) / 2 ;
            }


            this.data.app.stage.x = (view.width - this.currentSizes.width) / 2 //- 320;
            this.data.app.stage.y = (view.height - this.currentSizes.height) / 2;


           // console.log('this.data.app.stage.x ', this.data.app.stage.x)

        } else {
            view.style.height = '100%';
            this._gameScale = view.offsetWidth / view.width;

            // Считаем маньше какого размера игра не должна быть по ширине с учетом текущего скейла
            let safeWidth = this.data.safeWidth * this._gameScale;

            //Проверяем стала лы игра меньше минимально возможного значения по ширине
            //Если стала, то меняем ее рзмеры по высоте и вписывам максимально возможно по ширине
            if (parent.offsetWidth < safeWidth && checkSafeZone) {
                let h = ((parent.offsetWidth / safeWidth) * 100);
                view.style.height = h.toString() + '%';
            }
        }
    }

    correctSizeCanvas(checkSafeZone = true) {
        let item = this.data.app.stage;

        //Считаем соотношение сторон графики
        let ratio = item.width / item.height;

        //Выставляем размеры игры вписывая ее по высоте и пропорционально ставим размеры по ширине
        item.height = this.data.app.view.height;
        item.width = item.height * ratio;

        // Считаем маньше какого размера игра не должна быть по ширине с учетом текущего скейла
        let safeWidth = this.data.safeWidth * item.scale.x;
        let safeHeight = this.data.safeHeight * item.scale.y;

        //Проверяем стала лы игра меньше минимально возможного значения по ширине
        //Если стала, то меняем ее рзмеры по высоте и вписывам максимально возможно по ширине
        if (this.data.app.view.width < safeWidth && checkSafeZone) {
            item.width = item.width * (this.data.app.view.width / safeWidth);
            item.height = item.width / ratio;
        }
        /*if (this.app.view.height < safeHeight && $checkSafeZone) {
            item.width = item.width / ratio;
            item.height = item.height * (this.app.view.height / safeHeight)
        }*/

        //Позиционируем игру по ценрту канваса
        item.x = (this.data.app.view.width - item.width) / 2;
        item.y = (this.data.app.view.height - item.height) / 2;
    }

    get currentData() {
        return this._currentData;
    }
}
